import { Box } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { Modal } from "@/components/elements";
import { UserProfileTabBilling } from "@/components/widgets/UserProfile/components/TabBilling/TabBilling";

import type { FC } from "react";

export type BillingModalProps = {
  opened: boolean;
  onClose: () => void;
};

const BillingModal: FC<BillingModalProps> = ({ opened, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      fullScreen
      onClose={onClose}
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3,
      }}
      styles={{
        header: {
          paddingBottom: 0,
        },
        close: {
          color: "#143ab1",
        },
        body: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        },
      }}
      title={t("payments.plan_and_billing")}
    >
      <Box style={{ width: "100%" }}>
        <UserProfileTabBilling />
      </Box>
    </Modal>
  );
};

export default BillingModal;
